var map = {
	"./v1.jpg": 3682,
	"./v2.jpg": 8333,
	"./v3.jpg": 8755,
	"./v4.jpg": 8925,
	"./v5.jpg": 3132,
	"./v6.jpg": 5138,
	"./v7.jpg": 2404,
	"./v8.jpg": 5531,
	"./v9.jpg": 9109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7866;